import { axios } from 'api'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ConfigField from './ConfigField'

const StyledContainer = styled.div`
  max-width: 600px;
  p {
    margin: 0;
  }
  .msg {
    margin-top: 12px;
  }
  .btn {
    border-radius: 50px !important;
    padding: 0;
    width: 30px;
    height: 30px;
    font-size: 20px;
  }
  .form-check {
    display: flex;
    align-items: center;
    gap: 1rem;
    input {
      margin: 0;
    }
  }
  .flex {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`

const AdminConfigForm = () => {
  // State for each field's value and edit mode
  const [configList, setConfigList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchConfigs = async () => {
      setLoading(true)
      try {
        const res = await axios.get('/admin_configs/get_configs', {
          baseURL: '/admin'
        })
        setConfigList(res.data?.configs || [])
      } catch (err) {
        console.log(err)
      }
      setLoading(false)
    }
    fetchConfigs()
  }, [])
  return (
    <StyledContainer className='shadow-sm'>
      {loading ? (
        <p className='msg'>Loading Configurations...</p>
      ) : configList.length === 0 ? (
        <p className='msg'>No Configurations Available!</p>
      ) : (
        <div className='flex'>
          {configList.map((config) => (
            <ConfigField config={config} key={config.key} />
          ))}
        </div>
      )}
    </StyledContainer>
  )
}

export default AdminConfigForm
